// ==================================================================================================
//
// Notifications Functionality
//
// ==================================================================================================
const notifications = () => {
  let props = {};
  let els = {};

  let shownPopupModal = false;
  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$mainMenu         = $('.js-main-menu');
    els.$notification     = $('.js-menu-notification');
    els.$message          = els.$notification.find('.js-notification-message');
    els.$closeButton      = els.$notification.find('.js-notification-close');
    els.$bankRoutingImg   = $('.bankRoutingImg');
    els.$paymentButton    = $('#paymentButton');
  }

  const triggerNotification = ({ detail: { message, success } }) => {
    props.successClass = success ? 'successful' : 'unsuccessful'
    els.$notification.addClass(`is-active ${props.successClass}`)
    els.$message.text(message)

    setTimeout(closeNotification, 3000)
  }

  const closeNotification = () => {
    els.$notification.removeClass(`is-active ${props.successClass}`)
  }

  const showNotificationImg = (data = {}) => e => {

    document.body.classList.add('is-modal-open');
    
    let img = data.img || $(e.target).data('img');
    let klass = data.klass || $(e.target).data('class');
    let permanent = data.permanent || $(e.target).data('permanent') === "permanent";
    let text = data.text || $(e.target).data('text');
    
    $('<div />', {
        id: 'popupModal',
        class: klass,
        click: permanent ? () => null : removeNotificationImg()
    })
    .append(
      $('<div />', {
        class: 'imgHolder',
      })
      .append($('<img />', {
        src: img,
        background: 'red'
      }))
      .append($('<p />', {
        html: text,
      }))
    )
    .appendTo("body");

    shownPopupModal = true;
  }

  const removeNotificationImg = () => () => {
    document.body.classList.remove('is-modal-open');
    $('#popupModal').remove();
    shownPopupModal = false;
  }

  // Set up for responsive
  // ------------------------------------------------
  const setupResponsive = () => {
    return {
      'sm' : enable,
      'md' : enable,
      'lg' : enable,
      'xl' : enable
    }
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    els.$closeButton.on('click', closeNotification);
    window.addEventListener('CCM:Reservation', triggerNotification)
    props.isEnabled = true;

    els.$bankRoutingImg.on('click', shownPopupModal ? removeNotificationImg() : showNotificationImg());

    /* Show notifications after form is validated. Form validator will trigerr event with form name(class), and after that
       proper notification will be shown */
    global.addEventListener('validation:finished', ({ detail }) => {
      if (detail === "newPaymentForm") showNotificationImg({
          img: "/assets/logo--loader.gif",
          klass: "purple no-padding",
          permanent: "permanent",
          text: "Hang tight. Please do not resubmit. This may take a minute or two…"
      })()
    }, false);

    return;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    els.$closeButton.off('click', closeNotification);
    els.$bankRoutingImg.off('click', showNotificationImg());
    window.removeEventListener('CCM:Reservation', triggerNotification)
    props.isEnabled = false;

    return;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    enable();
    setupResponsive();
    return;
  }

  return {
    init,
    enable,
    disable,
    responsiveCallbacks: setupResponsive()
  };
}

export default notifications;
